import { createAction } from 'redux-actions';

export const menuActionTypes = {
  CLOSE_MENU: 'MENU/CLOSE_MENU',
  OPEN_MENU: 'MENU/OPEN_MENU',
  TOGGLE_MENU: 'MENU/TOGGLE_MENU'
};

export const menuActions = {
  closeMenu: createAction(menuActionTypes.CLOSE_MENU),
  openMenu: createAction(menuActionTypes.OPEN_MENU),
  toggleMenu: createAction(menuActionTypes.TOGGLE_MENU)
};
